
function createChangeCartFromEditLayerEvent(item, itemOption, quantity, pageViewId) {
    const styleId = item?.id;
    const price = itemOption.price;
    const formerPrice = itemOption.formerPrice;
    const currency = itemOption.currencyCode;
    const displayedPrice = price ? price : 0;
    const displayedFormerPrice = formerPrice ? formerPrice : 0;
    const itemOptionName = itemOption?.name;
    const articleNumber = item?.itemNumber;
    const availability = itemOption.availabilityType;
    const availabilityText = availability? availability : "";
    return {
        styleId: styleId,
        strikeOutPrice: displayedFormerPrice,
        displayedPrice: displayedPrice,
        currency: currency,
        artNr: articleNumber,
        artGr: itemOptionName,
        availability: availabilityText,
        quantity: quantity,
        ranking: "",
        shopFilter: "",
        pageViewId: pageViewId
    };
}

export default {
    createChangeCartFromEditLayerEvent
}